export class Acct
{
    storeid: string;
    accttype: string;
    password: string;
    role: string;   
    commissionmodel: string;
    rate: string;  
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/acctmodel.ts